import React, { useState } from "react";
import { Button } from "../common/Button";

interface ConfirmModalProps {
  message: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  size?: "sm" | "md" | "lg";
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  message,
  onConfirm,
  confirmText = "Conferma",
  cancelText = "Annulla",
  size = "md", 
}: ConfirmModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <>
      {/* Bottone per aprire la modale */}
      <Button
        onClick={openModal}
        variant="destructive"
        size={size}
      >
        Elimina
      </Button>

      {/* Modale */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white p-6 rounded shadow-lg w-80">
            <p className="mb-4">{message}</p>
            <div className="flex justify-end gap-3">
              <Button onClick={closeModal} variant="secondary">
                {cancelText}
              </Button>
              <Button
                onClick={() => {
                  onConfirm();
                  closeModal();
                }}
                variant="destructive"
              >
                {confirmText}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
